module.exports = __webpack_public_path__ + "img/Vangsgutane_Ingenioer_Knut_Berg_på_eventyr.2e358890.jpg";